// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StylesGuideH3 {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  color: gray;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Titles/H3/H3.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AACJ","sourcesContent":[".StylesGuideH3 {\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
